<template>
  <SmartLink :route="route" class="side-menu-logo">
    <UkaskoLogo
      class="side-menu-logo-icon"
      :width="100"
      :height="18"
    />
  </SmartLink>
</template>

<script>
import { UkaskoLogo } from '@/shared/ui/icons';
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    route: {
      type: String,
      default: '',
      required: true,
    }
  },
  components: { UkaskoLogo, SmartLink },
};
</script>

<style lang="scss" scoped>
.side-menu-logo {
  display: block;
  padding: 32px 16px 27px;

  &-icon {
    margin: 0 9px;
  }
}
</style>
